module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-cards-actions-wrapper"
  }, [(!_vm.isEditMode) ? _c('ul', {
    staticClass: "list-unstyled m-0"
  }, [_c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showEditTitlePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" " + _vm._s(_vm.$t('panels.edit_title')) + "\n    ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSegmentCard && _vm.paramsClient.nb_screen_segment !== 1),
      expression: "isSegmentCard &&  paramsClient.nb_screen_segment !== 1"
    }, {
      name: "close-popover",
      rawName: "v-close-popover.all",
      modifiers: {
        "all": true
      }
    }],
    class: {
      disabled: _vm.selectedSlides.length >= _vm.permission.nb_screen_segment && _vm.getNbSreenSegment,
    },
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('duplicated')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clone"
  }), _vm._v(" " + _vm._s(_vm.$t('panels.duplicateSegment')) + "\n    ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSegmentCard || _vm.paramsClient.nb_screen_segment === 1),
      expression: "!isSegmentCard || paramsClient.nb_screen_segment === 1"
    }, {
      name: "close-popover",
      rawName: "v-close-popover.all",
      modifiers: {
        "all": true
      }
    }],
    class: {
      disabled: _vm.selectedSlides.length >= _vm.permission.nb_screen_segment && _vm.getNbSreenSegment,
    },
    staticStyle: {
      "white-space": "nowrap"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('duplicated')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clone"
  }), _vm._v(" " + _vm._s(_vm.$t('panels.duplicateScreen')) + "\n    ")]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_transition && (_vm.index > 0 || _vm.startGeneric)),
      expression: "show_transition && (index > 0 || startGeneric)"
    }],
    attrs: {
      "id": "li-show-modal"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addTransition(_vm.card)
      }
    }
  }, [_c('i', {
    staticClass: "icon-transition"
  }), _vm._v(" Transition\n    ")]), _vm._v(" "), (_vm.showBtnDuration) ? _c('li', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('edit_duration_segment_action'),
      expression: "'edit_duration_segment_action'"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showEditDurationPanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(_vm._s(_vm.$t('panels.duration')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRemovable),
      expression: "isRemovable"
    }, {
      name: "close-popover",
      rawName: "v-close-popover.all",
      modifiers: {
        "all": true
      }
    }],
    staticClass: "text-danger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleDelete($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" " + _vm._s(_vm.$t('panels.deleteScreen')) + "\n    ")])]) : _c('div', {
    staticClass: "edit-panel",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "actions-wrapper"
  }, [_c('button', {
    staticClass: "btn btn-link btn-sm cancel-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleEditMode(true)
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left-alt"
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "close-popover",
      rawName: "v-close-popover.all",
      modifiers: {
        "all": true
      }
    }],
    ref: "closeBtn",
    attrs: {
      "hidden": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-sm cancel-btn",
    on: {
      "click": _vm.closePopover
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode === 'title'),
      expression: "editMode === 'title'"
    }],
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('panels.edit_title')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "title": _vm.$t('panels.title'),
      "placeholder": _vm.$t('panels.title'),
      "type": "text",
      "maxlength": _vm.getmaxLength
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.handleUpdate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode === 'duration'),
      expression: "editMode === 'duration'"
    }],
    staticClass: "form-group",
    class: {
      'has-error': _vm.hasError
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('panels.duration')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.durationInput),
      expression: "durationInput"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "title": _vm.$t('panels.duration'),
      "placeholder": _vm.$t('panels.duration'),
      "type": "text"
    },
    domProps: {
      "value": (_vm.durationInput)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.handleUpdate()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.durationInput = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v("Valeur invalide!")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-link btn-sm save-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleUpdate()
      }
    }
  }, [_c('span', {
    staticClass: "icon-save"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33123204","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel/CustomPanelCardActions.vue
// module id = 824
// module chunks = 1 3